'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isString2 = require('lodash/isString');

var _isString3 = _interopRequireDefault(_isString2);

var _isPlainObject2 = require('lodash/isPlainObject');

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _keys2 = require('lodash/keys');

var _keys3 = _interopRequireDefault(_keys2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var coerceSelection = function coerceSelection(select) {
  if (!select) {
    return [];
  } else if ((0, _isString3.default)(select)) {
    return [select];
  } else if ((0, _isPlainObject3.default)(select)) {
    return (0, _keys3.default)(select).reduce(function (acc, key) {
      return acc.concat(select[key] ? [key] : []);
    }, []);
  }
  return select;
};

exports.default = coerceSelection;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/substyle/lib/coerceSelection.js
// module id = 1015
// module chunks = 7